import React from 'react'
import ImageGallery from '../components/ImageGallery'
import images from '../images/images'

const imagesModalIllustrations = images["illustrations"][0];
const imagesThumbIllustrations = images["illustrations"][1];


const imagesModalTits = images["tits"][0];
const imagesThumbTits = images["tits"][1];

const imagesModalObjects = images["objects"][0];
const imagesThumbObjects = images["objects"][1];

const imagesModalMonsters = images["monsters"][0];
const imagesThumbMonsters = images["monsters"][1];

const imagesModal = images["others"][0].filter((pic ,index) => index === 0 || index === 7);
const imagesThumb = images["others"][1].filter((pic ,index) => index === 0 || index === 7);

const imagesBlob = images["blob"][0];
const imagesBlobThumbs = images["blob"][1];

const Skateboards = () => (
    <div>
        <ImageGallery imagesModal={imagesModalIllustrations.filter((pic, index) => index <= 7)} imagesThumb={imagesThumbIllustrations.filter((pic, index) => index <= 7)} tabName="ILLUSTRATION_CIRCLE" />

        <ImageGallery imagesModal={imagesModalIllustrations.filter((pic, index) => index >= 8)} imagesThumb={imagesThumbIllustrations.filter((pic, index) => index >= 8)} tabName="ILLUSTRATION_SQUARE" />
    </div>
)

export default Skateboards;



// WEBPACK FOOTER //
// ./src/pages/illustration.js